<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Проекты
                </div>
                <div class="ap-workspace-label-btn" v-on:click="confirmTransition()">
                    <SVGPlus/>
                </div>
            </div>
            <div class="ap-workspace-label-btn ap-add-left-margin">
                <label class="ap-search">
                    <input type="text" class="ap-search-input" placeholder="Найти проект" v-model="mask">
                </label>
            </div>
        </div>
        <vue-custom-scrollbar @ps-y-reach-end="scrollReachEnd">
        <div class="ap-workspace-table-container workspace-admin-scroll-part">
            <table class="result-table">
                <thead>
                <tr class="head-tr">
                    <th>№</th>
                    <th>Название</th>
                    <th>Дата создания</th>
                    <th>Менеджер</th>
                    <th>Заказчик</th>
                    <th>Изображение</th>
<!--                    <th>Редактировать по ссылке</th>-->
                    <th>Доступен в Lite</th>
                    <th class="field-edit">Опции</th>
                </tr>
                </thead>
                <tbody>
                <tr class="body-tr row" v-for="(value, index) in projects">
                    <td>
                        <span class="table-data">{{index+1}}</span>
                    </td>
<!--                    <td>-->
<!--                        <span class="table-data-central">{{value.guid}}</span>-->
<!--                    </td>-->
                    <td>
                        <span class="table-data">{{value.data_json.name}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{dateIntoRu(value.create_date)}}</span>
                    </td>
                    <td>
                        <span v-for="user in value.users" class="table-data">{{user.fullname}}</span>
                    </td>
                    <td>
                        <span v-show="value.customers.length === 0" class="table-data">Нет заказчика</span>
                        <span v-show="value.customers.length > 0" v-for="customer in value.customers" class="table-data">{{customer.name}}</span>
                    </td>

                    <td>
                        <img class="ap-table-img" :src="getFirstImg(value.data_json.photoList)"/>
                    </td>
<!--                    <td>-->
<!--                        <span class="table-data">{{convertToWord(value.open_write)}}</span>-->
<!--                    </td>-->
                    <td>
                        <span class="table-data">{{convertToWord(value.open_read)}}</span>
                    </td>
                    <td>
                        <div class="edit-button-group">
                            <div class="table-svg-button" v-on:click="editRow(value)">
                                <SVGAdminEditRow/>
                            </div>
                            <div class="table-svg-button" v-on:click="confirm(value)">
                                <SVGAdminDeleteRow/>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="waitingResponseToProjectsRequest" class="ap-loader-grid">
                <SpinnerTwo/>
                <div class="ap-loader-text">
                    Идет загрузка проектов ...
                </div>
            </div>
        </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {urlForFileStorage, urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    import EditProject from "../../Modal/AdminPage/ProjectsPage/EditProject";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "AdminProjects",
        mixins: [urlForStaticVue, urlForFileStorage],
        components: {
            SpinnerTwo,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        data() {
            return {
                timerId: null
            }
        },
        computed: {
            mask: {
                get() {
                    return this.$store.state.adminPanel.projects.mask;
                },
                set(value) {
                    this.$store.commit('adminPanel/projects/MASK', value);
                    if (this.timerId) {
                        clearTimeout(this.timerId);
                        this.timerId = null;
                    }
                    this.timerId = setTimeout(() => {
                        this.$store.commit('adminPanel/projects/CLEAR_PROJECTS');
                        this.$store.dispatch('adminPanel/projects/GET_PROJECTS');
                        this.timerId = null;
                    }, 500);
                }
            },
            projects() {
              return this.$store.getters["adminPanel/projects/PROJECTS"];
          },
          waitingResponseToProjectsRequest(){
              return this.$store.state.adminPanel.projects.waitingResponseToProjectsRequest;
          }
        },
        methods: {
            dateIntoRu(createDate) {
                let date = new Date(createDate).toLocaleString('ru', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                return date;
            },
            scrollReachEnd() {
                this.$store.dispatch('adminPanel/projects/GET_PROJECTS');
            },
            // urlForPhoto(url) {
            //     return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            // },
            getFirstImg(photoList){
                for (let idPhoto in photoList) {
                    return this.urlForFileStorage(photoList[idPhoto].src);
                }
                return this.urlForStatic('img/No_Picture.jpg');
            },
            addProject(){
                this.$router.push({name: 'projects'}).catch(() => {});
            },
            editRow(projectData) {
                console.log(projectData);
                this.$modal.show(EditProject, {projectData}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 516,
                    draggable: true,
                });
            },
            deleteRow(projectUUID) {
                return () => {this.$store.dispatch('adminPanel/projects/DELETE_PROJECT', projectUUID)};
            },
            confirm(project) {
                const title = `Удалить проект "${project.data_json.name}"?`
                const text = 'Запись о данном проекте будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(project.guid)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            goAddProject() {
                return async () => {
                    const projectGUID = await this.$store.dispatch('projectList/CREATE_NEW_PROJECT');
                    await this.$router.push({
                        name: "loadPhoto",
                        params: {projectUUID: projectGUID}
                    }).catch(() => {});
                    // let route = this.$router.resolve({name: 'projects'});
                    // window.open(route.href, '_blank');
                }
            },
            confirmTransition(project) {
                const title = `Перейти к созданию проекта"?`
                const text = 'Вы будете перемещены в конфигуратор для проектирования, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.goAddProject()}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            convertToWord(value) {
                if (value) {
                    return 'Да'
                } else {
                    return 'Нет'
                }
            },
        },
        mounted() {
            this.$store.dispatch('adminPanel/projects/GET_PROJECTS');
        }
    }
</script>

<style scoped>

</style>
